import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { calGuard } from '@cvx/cal-angular';
import { devToolsGuard } from './guards/dev-tools.guard';
import { NotAllowedComponent } from './layout/not-allowed/not-allowed.component';

const routes: Routes = [
  { path: '', redirectTo: '/initiatives', pathMatch: 'full' },
  { path: 'not-allowed', component: NotAllowedComponent },
  {
    path: 'initiatives',
    loadChildren: () =>
      import('./features/reports/reports.module').then((m) => m.ReportsModule),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'approvals',
    loadChildren: () =>
      import('./features/approvals/approvals.module').then(
        (m) => m.ApprovalsModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'forecasts',
    loadChildren: () =>
      import('./features/forecasts/forecasts.module').then(
        (m) => m.ForecastsModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'portfolio-backlogs',
    loadChildren: () =>
      import('./features/portfolio-backlog/portfolio-backlog.module').then(
        (m) => m.PortfolioBacklogModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'settings',
    loadChildren: () =>
      import('./features/settings/settings.module').then(
        (m) => m.SettingsModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'cutline',
    loadChildren: () =>
      import('./features/cutline/cutline.module').then(
        (m) => m.CutlineModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'myportfolio',
    loadChildren: () =>
      import('./features/myportfolio/myportfolio.module').then(
        (m) => m.MyPortfolioModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'heatmap',
    loadChildren: () =>
      import('./features/heatmap/heatmap.module').then(
        (m) => m.HeatmapModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'mybreakinoutapprovals',
    loadChildren: () =>
      import('./features/break-in-outs-approvals/break-in-outs-approvals.module').then(
        (m) => m.BreakInOutsApprovalsModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'newprojectsbreakin',
    loadChildren: () =>
      import('./features/new-projects-break-in/new-projects-break-in.module').then(
        (m) => m.NewProjectsBreakInModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'linked-records',
    loadChildren: () =>
      import('./features/linked-records/linked-records.module').then(
        (m) => m.LinkedRecordsModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'dashboard',
    loadChildren: () =>
      import('./features/powerbi-dashboard/powerbi-dashboard.module').then(
        (m) => m.PowerbiDashboardModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },

  {
    path: 'manpower',
    loadChildren: () =>
      import('./features/manpower/gantt-chart.module').then(
        (m) => m.GanttChartModule
      ),
    canActivate: [calGuard, devToolsGuard],
  },
  {
    path: 'capex',
    loadChildren: () =>
      import('./features/capex/capex.module').then(
        (m) => m.CapexModule
      ),
    canActivate: [calGuard, devToolsGuard],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
